<template>
  <div class="main">
    <el-form
      :model="data"
      status-icon
      ref="form"
      label-width="80px"
      class="demo-ruleForm"
      style="width:650px"
      :rules="rules2"
    >
      <el-form-item label="手机号码" prop="phone">
        <el-input
          type="text"
          v-model="data.phone"
          placeholder="请验证用户名以获取手机号"
        ></el-input>
        <el-button
          type="primary"
          @click="getCode"
          :disabled="timeOut"
          id="phoneCode"
          >获取验证码</el-button
        >
      </el-form-item>
      <el-form-item label="验证码" prop="code">
        <el-input
          type="text"
          v-model="data.code"
          :disabled="checkPhone"
          placeholder="请输入验证码"
        ></el-input>
      </el-form-item>
      <el-form-item label="新密码" v-if="checkCode" prop="newPass">
        <el-input
          type="password"
          v-model="data.newPass"
          :disabled="checkPhone"
          placeholder="请输入新密码"
        ></el-input>
      </el-form-item>
      <el-form-item label="确认密码" v-if="checkCode" prop="checkPass">
        <el-input
          type="password"
          v-model="data.checkPass"
          :disabled="checkPhone"
          placeholder="请再次输入新密码"
        ></el-input>
      </el-form-item>
      <el-form-item v-if="checkCode">
        <el-button
          type="primary"
          @click="submitForm2('data')"
          :disabled="checkPhone"
          >提交</el-button
        >
        <!-- <router-link to="/login">返回登录页</router-link> -->
        <el-button @click="goBack">返回</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  data() {
    var validateName = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入用户名"));
      } else {
        callback();
      }
    };
    var validatePhone = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入电话号码"));
      } else if (!/^([1]\d{10})$/.test(value)) {
        callback(new Error("请输入正确电话号码"));
      } else {
        callback();
      }
    };
    var validateCode = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入验证码"));
      } else {
        callback();
      }
    };
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else if (value.trim() === "") {
        callback(new Error("密码中不能为空格"));
      } else if (value.indexOf(" ") !== -1) {
        callback(new Error("密码中不能包含空格"));
      } else {
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.data.newPass) {
        callback(new Error("两次输入密码不一致!"));
      } else if (value.trim() === "") {
        callback(new Error("密码中不能为空格"));
      } else if (value.indexOf(" ") !== -1) {
        callback(new Error("密码中不能包含空格"));
      } else {
        callback();
      }
    };
    return {
      checkPhone: true,
      checkCode: true,
      timeOut: false,
      rules2: {
        name: [
          {
            validator: validateName,
            trigger: "blur"
          }
        ],
        newPass: [
          {
            validator: validatePass,
            trigger: "blur"
          }
        ],
        checkPass: [
          {
            validator: validatePass2,
            trigger: "blur"
          }
        ],
        code: [
          {
            validator: validateCode,
            trigger: "blur"
          }
        ],
        phone: [
          {
            validator: validatePhone,
            trigger: "change"
          }
        ]
      },
      data: {
        name: "",
        phone: "",
        code: "",
        newPass: "",
        checkPass: ""
      },
      userId: null,
      stopTime: 0
    };
  },
  computed: {
    ph() {
      return this.$refs["form"].fields[0].validateMessage;
    }
  },
  methods: {
    handleIconClick() {
      if (document.getElementById("password").type === "password") {
        document.getElementById("password").type = "text";
      } else {
        document.getElementById("password").type = "password";
      }
    },
    submitForm() {
      this.dialogFormVisible = true;
    },
    submitForm2(formName) {
      this.$refs.form.validate(valid => {
        if (valid) {
          let params = new URLSearchParams();
          params.append("phone", this.data.phone);
          params.append("authCode", this.data.code);
          params.append("newpwd", this.data.newPass);
          params.append("type", 2);
          this.$axiospost("auth/token/saveCompanyUserPwd", params).then(res => {
            if (res.data.status === 10000) {
              this.$router.push("/login");
            }
          });
        }
      });
    },
    goBack() {
      this.stopTime = -1;
      this.$router.go(-1);
    },
    // 获取短信验证码
    getCode(time) {
      this.$refs.form.validateField("phone", error => {
        if (!error) {
          let seconds = 59;
          let intervalName = setInterval(() => {
            this.timeOut = true;
            let num = seconds--;
            if (document.getElementById("phoneCode")) {
              document.getElementById("phoneCode").innerText =
                num + "s" + "再次发送";
            }
            if (!num) {
              clearInterval(intervalName);
              this.timeOut = false;
              document.getElementById("phoneCode").innerText = "获取验证码";
              // return;
            }
            if (this.stopTime === -1) {
              clearInterval(intervalName);
              this.timeOut = false;
            }
          }, 1000);

          let params = new URLSearchParams();
          params.append("phone", this.data.phone);
          this.$axiospost("auth/token/getCompanyUserAuthCode", params).then(
            res => {
              if (res.data.status === 10000) {
                this.$message.success("发送成功");
                this.checkPhone = false;
              } else {
                this.$message.error("发送失败");
                this.checkPhone = true;
              }
            }
          );
        }
      });
    }
  },
  mounted() {},
  created() {},
  destroyed() {}
};
</script>

<style lang="less" scoped>
.main {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  background: black !important;
  > .el-form {
    padding: 30px 20px 20px 20px;
    width: 30%;
    // height: 25%;
    background-color: #181c2e;
    border-radius: 5px;
    margin: 0 auto;

    > .el-form-item {
      text-align: left;
    }

    .el-input {
      width: 380px;
    }

    span {
      color: #666;
      float: right;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/password/admin/index.vue